module.exports = __webpack_public_path__ + "static/media/test18_2.6bfac834.png";